import React, { useContext } from 'react';
import { RuntimeContext } from '../../../common/RuntimeContext';

export default () => {
    const data = {
        type: 'auth0:silent-authentication',
        hash: window.location.hash
    };
    window.parent.postMessage(data, useContext(RuntimeContext).pathsWeb.clientUrl);

    return <div>Silent</div>;
};
